






















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IExternalMenuItemConfiguration } from "../../domain/configuration";
import { FormatReference, FormatSet } from "../../domain/format";
import { NavigationPane } from "../panes";
import NewDocumentFormatSelector from "./selectors/NewDocumentFormatSelector.vue";
import { FormatValidatableMixin } from "../format/mixins";
import { WindowOpener } from "../system/utilities";
import { WindowsOpenRequest } from "../../domain/localhost/items";
import { Patient } from "../../domain/patient";
import { ExternalMenu } from "./viewers/menus";

// 弘前大でフォーマット指定したあとに患者を切り替えて次々に文書編集画面を開きたいとの要望が緊急であり、
// NewDocumentFormatSelectViewに患者切り替えボタンを追加するよりは別画面を追加したほうが安全な見込みだっため、画面追加した経緯がある
@Component({
  components: {
    formatSelector: NewDocumentFormatSelector,
    NavigationPane,
    ExternalMenu,
  },
})
export default class FormatListView extends Mixins(FormatValidatableMixin) {
  @Prop({ default: null })
  formatName: string;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  defaultToolTabName: string;

  @Prop()
  shouldIndicatePrintButtonForcibly: boolean;

  data(): any {
    return {
      format: null as FormatReference,
      selectedFormatSet: null as FormatSet,
    };
  }
  format: FormatReference;
  selectedFormatSet: FormatSet;

  get enableFormatSetTabs(): boolean {
    return this.$configuration.behavior.format.formatSet.isEnable;
  }

  get shouldShowDocumentListButton(): boolean {
    return this.$configuration.behavior.format.list.menu.documentList.isEnable;
  }

  get externalMenuItems(): IExternalMenuItemConfiguration[] {
    return this.$configuration.behavior.format.list.menu.externalMenus;
  }

  openEditor(): void {
    this.validateAndOpenEditor();
  }

  private async validateAndOpenEditor(): Promise<void> {
    if (!this.format) { return; }
    const isOk = await this.validateFormat(this.format, false);
    if (!isOk) { return; }
    const patient = await this.selectPatient();
    if (!patient) { return; }
    this.openEditNewDocumentWindow(this.format, patient);
  }

  private async validateAndOpenEditorSet(): Promise<void> {
    if (!this.selectedFormatSet) { return; }
    const availableFormats = this.selectedFormatSet.formats.filter(f => !f.deleted && !f.expired);
    if (availableFormats.length === 0) {
      return;
    }
    const isOk = await this.validateFormats(availableFormats, false);
    if (!isOk) { return; }
    const patient = await this.selectPatient();
    if (!patient) { return; }
    if (this.$configuration.behavior.format.formatSet.shouldOpenWindowsWithUrlScheme) {
      const request = this.createWindowsOpenRequest(availableFormats, patient);
      await WindowOpener.requestOpenWindows(request);
    } else {
      for (const format of availableFormats) {
        try {
          // 連続で開くにはブラウザのpopup brokcerを解除しておく必要あり
          this.openEditNewDocumentWindow(format, patient);
        } catch (e) {
          this.$error("エラー", "新規ウィンドウを開く処理中にエラーが発生しました。", e);
        }
        // 不要かもだが念のためsleepを入れている
        await this.$sleep(100);
      }
    }
  }

  private async selectPatient(): Promise<Patient> {
    return this.$commonDialogs.patient.finder.show(null, true);
  }

  private createWindowsOpenRequest(formats: FormatReference[], patient: Patient): WindowsOpenRequest {
    const request = new WindowsOpenRequest();
    request.urls = Enumerable.from(formats)
      .select(f => WindowOpener.toUrlEncodedUrl("/EditNewDocument", this.createOpenEditNewDocumentWindowParameter(f, patient)))
      .toArray();
    return request;
  }

  private openEditNewDocumentWindow(format: FormatReference, patient: Patient): void {
    // 別Windowで開く.(完全SPAにするとメモリリーク発生による問題が顕在化しやすくなる恐れがあるため.)
    this.$openWindow(
      "/EditNewDocument",
      this.createOpenEditNewDocumentWindowParameter(format, patient),
    );
  }

  private createOpenEditNewDocumentWindowParameter(format: FormatReference, patient: Patient): { [key: string]: string } {
    // 文書セットを考えなければここで患者IDを指定しなくても開いた先で検索すればよいのだが、
    // 文書セットを開いたときに異なる患者となるのはよくないので患者指定してから開くようにしている
    return {
      patientNo: patient.id,
      formatId: format.id.toString(),
      defaultToolTabName: this.defaultToolTabName,
      shouldIndicatePrintButtonForcibly: (this.shouldIndicatePrintButtonForcibly != null) ? this.shouldIndicatePrintButtonForcibly.toString() : null,
    };
  }

  onFormatSetSelectionChanged(value: FormatSet): void {
    this.selectedFormatSet = value;
  }

  onFormatSetDoubleClicked(): void {
    this.validateAndOpenEditorSet();
  }

  openDocumentList(): void {
    this.$openWindow("/ShowDocumentList");
  }
}
